import React from "react";
import { arrayMove } from "react-sortable-hoc";
import { getMessage } from "../../lib/translator";
import { Dialog, Popup } from "../Popup";
import getLayout from "./LayoutUtils/getLayout";
import { isExtensionEnabled } from "../../lib/auth";

import {
  dualImageLayouts,
  availableComponents,
  SortableList,
  formatResponse,
  saveLayouts,
  getSelectOptionsData,
  LayoutSelectionList,
  LayoutOptions,
} from "./LayoutUtils/utils";
import Layout from "./LayoutUtils/layout";
import { hideLayouts } from "./LayoutUtils/constants";
import "./style.css";

export default class LayoutManager extends React.Component {
  constructor(props) {
    super(props);
    this.pages = [this.props.page];
    let layouts =
      (this.props.layouts && this.props.layouts.filter(Boolean)) || [];
    this.state = {
      values: {
        layouts: layouts,
      },
      editing: false,
      showPrompt: false,
      showLayoutPopup: false,
      showDialog: false,
      currentComponent: "Images",
    };
    this.data = [];
    this.currentLayout = {};
    this.selectOptionsData = {
      categories: [],
      tags: [],
      brands: [],
    };
    this.listView = this.listView.bind(this);
  }

  addLayout = (layoutName, data) => {
    const layout = {
      name: layoutName,
      data: data,
    };
    this.data.push(layout);
    this.setState({
      showLayoutPopup: false,
    });
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.data = arrayMove(this.data, oldIndex, newIndex);
    this.forceUpdate();
  };

  setDataCallback = (dataFor, options) => {
    this.selectOptionsData[dataFor] = options;
    this.setState({
      [`${dataFor}DataLoaded`]: true,
    });
  };

  layoutData = () => {
    this.data = formatResponse(
      this.props?.layouts,
      this.pages[this.state?.page]
    );
    this.originalData = this.data;

    if (!this.state?.categoryDataLoaded) {
      getSelectOptionsData(
        "category",
        "categories",
        this.state.categoryDataLoaded,
        this.setDataCallback
      );
    }
    if (this.pages.includes("tag") && !this.state?.tagDataLoaded) {
      getSelectOptionsData(
        "tag",
        "tags",
        this.state.tagDataLoaded,
        this.setDataCallback
      );
    }
    if (this.pages.includes("brand") && !this.state?.brandDataLoaded) {
      getSelectOptionsData(
        "brand",
        "brands",
        this.state.brandDataLoaded,
        this.setDataCallback
      );
    }
  };

  componentDidMount() {
    this.layoutData();
    if (!isExtensionEnabled("Whatmore")) {
      delete availableComponents["WhatsMore"];
    }
  }

  onAddClick = () => {
    this.setState({
      showLayoutPopup: true,
    });
  };

  onRemoveClick = (index) => {
    this.setState({
      showPrompt: false,
      deleteIndex: "",
    });
    this.handleSaveLayouts(index);
    window.scrollTo({
      top: this.currentLayout.top,
      behavior: "smooth",
    });
  };

  onEditClick = (layoutIndex, top) => {
    const layout = this.data[layoutIndex];

    Object.assign(this.currentLayout, layout);
    this.currentLayout.top = top;
    this.setState({
      editing: true,
      layoutIndex,
    });
    window.scrollTo({
      top,
      behavior: "smooth",
    });
  };

  showPrompt = (index) => {
    this.setState({
      showPrompt: true,
      deleteIndex: index,
    });
  };

  handleSaveLayouts = (index, formData = null) => {
    this.setState({ submitting: true });

    const updatedLayouts = saveLayouts(this.data, index, formData);
    this.data = updatedLayouts;
    this.props.updateLayoutsData(updatedLayouts);
    this.setState({
      values: { ...this.state.values, layouts: updatedLayouts },
      submitting: false,
      editing: false,
      showDialog: true,
      error: false,
      errors: {},
    });
  };

  reorderLayout = () => {
    this.handleSaveLayouts();
  };

  listView = () => {
    const View = () => {
      return (
        <>
          <SortableList
            items={this.data}
            onSortEnd={this.onSortEnd}
            lockAxis="y"
            helperClass="is-dragging"
            onEditClick={this.onEditClick}
            onRemoveClick={this.showPrompt}
          />
          <div className="add-layout-section">
            ——<span className="xs-hidden">———————</span>
            <button className="add-layout-btn" onClick={this.onAddClick}>
              {getMessage("themes.add.text")}
            </button>
            ——<span className="xs-hidden">——————</span>
          </div>
        </>
      );
    };
    return (
      <div className="themes-customize">
        <View />
        {this.data.length > 0 && (
          <div className="button-wrapper">
            <button
              className="button button-white"
              type="button"
              onClick={this.cancelReordering}
            >
              {getMessage("order.form.cancel.text")}
            </button>
            <button
              className="button primary"
              type="button"
              onClick={this.reorderLayout}
            >
              save
            </button>
          </div>
        )}
      </div>
    );
  };

  getRespectiveComponents = (component) => {
    this.setState({
      currentComponent: component,
    });
  };

  render() {
    const View = () => {
      if (this.state.editing) {
        const layout = this.data[this.state.layoutIndex];
        const layoutInfo =
          getLayout(
            this.state.page,
            layout.name,
            this.pages,
            this.selectOptionsData
          ) || {};
        const top = this.currentLayout.top;
        return (
          <Layout
            key={this.state.layoutIndex}
            top={top}
            data={{ ...layout.data, ...layout.value, name: layout.name }}
            preview={layoutInfo.preview}
            fields={layoutInfo.fields}
            name={layout.name}
            page={this.pages[0]}
            onSaveClick={(form) => {
              this.handleSaveLayouts(this.state.layoutIndex, form);
            }}
            onCancel={() => {
              this.setState({
                editing: false,
              });
            }}
            onRemove={() => {
              console.info("Remove this layout");
            }}
            sortable
            editing={this.state?.editing}
          />
        );
      }
      return <this.listView />;
    };
    return (
      <>
        <View />
        <div className="add-layout">
          <div className={`add-layout`}>
            {this.state.showLayoutPopup && (
              <>
                <Popup
                  show={this.state.showLayoutPopup}
                  heading={getMessage("themes.selection.heading")}
                  className="add-new-layout-popup"
                  close={(e) =>
                    this.setState({
                      showLayoutPopup: false,
                    })
                  }
                >
                  {
                    <div className="layout-main-content">
                      <ul>
                        <LayoutSelectionList
                          availableComponents={availableComponents}
                          hideLayouts={hideLayouts}
                          currentComponent={this.state.currentComponent}
                          getRespectiveComponents={this.getRespectiveComponents}
                        />
                      </ul>

                      <LayoutOptions
                        availableComponents={availableComponents}
                        currentComponent={this.state.currentComponent}
                        dualImageLayouts={dualImageLayouts}
                        theme={this.props.theme}
                        pages={this.pages}
                        page={this.state.page}
                        addLayout={this.addLayout}
                      />
                    </div>
                  }
                </Popup>
              </>
            )}
            <Dialog
              show={this.state.showDialog}
              className={this.state.error ? "warn" : "success"}
              title={
                this.state.error
                  ? getMessage("themes.layout.save.title.error")
                  : getMessage("themes.layout.save.title.success")
              }
              information={
                this.state.error
                  ? getMessage("themes.error." + this.state.error)
                  : getMessage("themes.layout.save.success")
              }
              closeText={getMessage("themes.dialog.okText")}
              close={(e) => {
                this.setState({
                  showDialog: false,
                });
              }}
            />
            <Dialog
              show={this.state.showPrompt}
              title={getMessage("themes.dialog.promt.title")}
              okText={getMessage("themes.dialog.okText")}
              closeText={getMessage("themes.dialog.closeText")}
              information={getMessage("themes.layout.delete.warning")}
              close={() =>
                this.setState({
                  showPrompt: false,
                  deleteIndex: "",
                })
              }
              onOk={() => this.onRemoveClick(this.state.deleteIndex)}
            />
          </div>
        </div>
      </>
    );
  }
}
